import client from "../utils/client";

const fetchGroupGames = async (props) => {
  const { contest_id } = props;

  const url = `/api/group_stage_games`;
  const response = await client().get(url, {
    params: {
      contest_id,
    },
  });
  return response;
};

const fetchKOGames = async (props) => {
  const { contest_id } = props;

  const url = `/api/knockout_games`;
  const response = await client().get(url, {
    params: {
      contest_id,
    },
  });
  return response;
};

export { fetchGroupGames, fetchKOGames };
